export const getCroppedImg = (imageSrc, croppedAreaPixels) => {
  const canvas = document.createElement('canvas');
  canvas.width = croppedAreaPixels.width;
  canvas.height = croppedAreaPixels.height;
  const ctx = canvas.getContext('2d');

  const image = new Image();
  image.crossOrigin = 'anonymous'; // ✅ Important for blob & CORS
  image.src = imageSrc;

  return new Promise((resolve, reject) => {
    image.onload = () => {
      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height
      );

      canvas.toBlob((blob) => {
        if (!blob) {
          console.error('❌ Failed to generate blob from canvas');
          return reject(new Error('Canvas is empty'));
        }
        resolve(blob);
      }, 'image/jpeg');
    };

    image.onerror = (err) => {
      console.error('❌ Image load error:', err);
      reject(err);
    };
  });
};
